export const GRANT_PERMISSIONS = 'grant_permissions';
export const KANBAN_BOARD_CREATE = 'kanban_board_create';
export const KANBAN_PERMISSION_CARD = 'kanban_permission_card';
export const TRANSPORT_ADMINISTRATION = 'transport_administration';
export const KANBAN_BOARD_EDIT = 'kanban_board_edit';
export const KANBAN_BOARD_REMOVE = 'kanban_board_remove';
export const TRANSPORT_MANUAL = 'transport_manual';
export const KANBAN_BOARD_READ = 'kanban_board_read';
export const VEHICLE_CREATE = 'create_vehicle'; //done
export const VEHICLE_EDIT = 'edit_vehicle'; //done
export const VEHICLE_REMOVE = 'remove_vehicle'; //done
export const VEHICLE_SEARCH_SETTING_READ = 'vehicle_search_settings_read'; // done
export const VEHICLE_SEARCH_SETTING_EDIT = 'vehicle_search_settings_edit'; // done
export const VEHICLE_CRUD = 'vehicle_crud'; // ?? need to discuss
export const VEHICLE_DETAILS_BUTTON = 'vehicle_details_button'; //done
export const VEHICLE_INVOICES_BUTTON = 'vehicle_invoices_button'; //done
export const VEHICLE_LOGS = 'vehicle_logs'; //done ? need to discuss. Log method is general.
export const VEHICLE_DOWNLOAD_IMAGES = 'vehicle_download_images'; //done
export const VEHICLE_HEXON_BUTTON = 'vehicle_hexon_button'; //done
export const VEHICLE_ACTIONS_BUTTON = 'vehicle_actions_button'; // frontend handles
export const VEHICLE_TAKEN_BUTTON = 'vehicle_taken_button'; // frontend handles
export const VEHICLE_ADD_TO_INDEWAL_WEBSITE = 'vehicle_add_to_indewal_website';
export const VEHICLE_EXTRA_COSTS_CRUD = 'vehicle_extra_costs_crud'; // frontend handles
export const VEHICLE_TRANSPORT_CRUD = 'vehicle_transport_crud'; // done
export const VEHICLE_INSPECTION_CRUD = 'vehicle_inspection_crud'; // frontend handles
export const VEHICLE_ADD_OUTGOING_BPM_INVOICE = 'vehicle_add_outgoing_bpm_invoice'; //done
export const VEHICLE_SET_INCOMING_REST_BPM = 'vehicle_set_incoming_rest_bpm'; //done
export const VEHICLE_ADD_TO_ORDER = 'vehicle_add_to_order'; // done
export const VEHICLE_SEARCH_SETTING_CRUD = 'vehicle_search_setting_crud'; // done
export const VEHICLE_DOCUMENTS_UPLOAD = 'vehicle_documents_upload'; //done
export const VEHICLE_DOCUMENTS_CRUD = 'vehicle_documents_crud'; // done
export const EDIT_VEHICLE_STATUS = 'edit_vehicle_status'; // frontend handles
export const COMPANY_SEARCH_SETTING_READ = 'company_search_settings_read'; // method does not exist
export const COMPANY_SEARCH_SETTING_EDIT = 'company_search_settings_edit'; // method does not exist
export const COMPANY_SEARCH_SETTING_CRUD = 'company_search_setting_crud'; // method does not exist
export const COMPANY_CRUD = 'company_crud'; //done
export const COMPANY_EDIT_COMPANY_TYPE = 'company_edit_company_type'; // frontend handles
export const COMPANY_EDIT_CUSTOMERNUMBER = 'company_edit_customernumber'; // frontend handles
export const COMPANY_EDIT_COMPANY_FROM_EU = 'company_edit_company_from_eu'; // frontend handles
export const COMPANY_EDIT_IBAN = 'company_edit_iban'; // frontend handles
export const COMPANY_EDIT_BTW_NUMBER = 'company_edit_btw_number'; // frontend handles
export const COMPANY_SYNC_WITH_EXACT = 'company_sync_with_exact'; //done
export const COMPANY_DOCUMENTS_UPLOAD = 'company_documents_upload'; //done
export const COMPANY_DOCUMENTS_CRUD = 'company_documents_crud'; //done
export const COMPANY_PARENT_EXACT = 'company_parent_exact'; //done
export const COMPANY_EDIT_VINDAT_PAYMENTCONDITION = 'company_edit_vindat_paymentcondition'; //frontend handles
export const COMPANY_FINANCIAL_DETAILS = 'company_financial_details'; // frontend handles
export const EDIT_COMPANY_STATUS = 'edit_company_status'; //frontend handles
export const INVOICE_CREATE = 'invoice_create'; //done
export const INVOICE_EDIT = 'invoice_edit'; //done
export const INVOICE_DELETE = 'invoice_delete'; //done
export const INVOICE_CRUD = 'invoice_crud'; //done
export const INVOICES_PAGE = 'invoice_page'; //frontend handles
export const PURCHASING_DATA_CRUD = 'purchasing_data_crud'; //done
export const PURCHASING_PRICES_CRUD = 'purchasing_prices_crud'; //done
export const SALES_DATA_CRUD = 'sales_data_crud'; //done
export const SALES_PRICES_CRUD = 'sales_prices_crud'; //cone
export const USERS_CRUD = 'users_crud'; //done
export const USERS_SEARCH_SETTING_READ = 'users_search_settings_read'; //does not exist yet
export const USERS_SEARCH_SETTING_EDIT = 'users_search_settings_edit'; // does not exist yet
export const LOGIN_PERMISSIONS = 'login_permissions'; //frontend handles
export const TOOLS_CRUD = 'tools_crud'; //frontend handles
export const ORB_CRUD = 'orb_crud'; //done
export const EMAIL_HISTORY_PAGE = 'email_history_page'; //done
export const WORKFLOW_CRUD = 'workflow_crud'; //done
export const WORKFLOW_SELECT = 'workflow_select';
export const STATISTICS_PAGE = 'statistics_page'; //frontend handles
export const DEP_FINANCE = 'DEP_FINANCE';
export const DEP_COMMERCE = 'DEP_COMMERCE';
export const DEP_WALSTREET = 'DEP_WALSTREET';
export const DEP_ADMINISTRATION = 'DEP_ADMINISTRATION';
export const DEP_IT = 'DEP_IT';
export const DEP_WORKSHOP = 'DEP_WORKSHOP';
export const DEP_ADMIN = 'DEP_ADMIN';
export const DEP_TRANSPORT = 'DEP_TRANSPORT';
